import { AccountAvatar, AccountAvatarProps } from './ethereum/account-avatar';

export default function EthereumAccountAvatar(props: AccountAvatarProps) {
  return <AccountAvatar {...props} />;
}
